import { Experience } from '@winelivery-org/wl-client-sdk-js/src/models/experience/experience';
import { useTranslations } from 'next-intl';

import ExperienceItem from './ExperienceItem';

interface Props {
  data: Experience[];
}

export default function Experiences(props: Props) {
  const t = useTranslations('bar');

  if (props.data.length === 0) {
    return null;
  }

  return (
    <div className="container mx-auto">
      <div className="pb-4">
        <h2 className="font-bold mb-3 pt-6 text-greyscale-title">
          {t('detail.experiences')}
        </h2>
        <ul className="flex space-x-4 -mx-4 overflow-x-scroll px-4 pb-4 mb-0">
          {props.data.map((experience) => (
            <ExperienceItem
              id={experience.id}
              image={experience.images![0]}
              loyaltyPointsPrice={experience.loyaltyPointsPrice || 0}
              price={experience.price}
              title={experience.title}
            />
          ))}
        </ul>
      </div>
    </div>
  );
}
